import React from 'react';
import { Embed } from 'semantic-ui-react';
import { createComponent } from "../../../wayin-react";
import { getFacebookId } from "../../../util";
var FacebookVideo = createComponent({
  displayName: 'FacebookVideo',
  render: function render(_ref) {
    var src = _ref.src,
        id = _ref.id;

    if (!id) {
      id = getFacebookId(src);
    }

    return /*#__PURE__*/React.createElement(Embed, {
      active: true,
      autoplay: false,
      url: "//www.facebook.com/video/embed?video_id=" + id
    });
  }
});
export default FacebookVideo;
//# sourceMappingURL=facebook-video.js.map